import * as React from "react";
import { cn } from "../../lib/utils";

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> { }

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, ...props }, ref) => {
    return (
      <input
        ref={ref}
        className={cn(
          // Base styles
          "flex w-full rounded-lg bg-gray-100 text-sm text-gray-900 placeholder:text-gray-400",
          "px-3 py-2 shadow-sm transition-all duration-150 ease-in-out",

          // Borderless, subtle focus outline
          "outline-none border border-transparent focus:border-gray-300 focus:ring-2 focus:ring-[#885ABB]",

          // Hover + focus feel
          "hover:bg-gray-50 focus:bg-white",

          // Disabled
          "disabled:opacity-50 disabled:cursor-not-allowed",

          className
        )}
        {...props}
      />
    );
  }
);

Input.displayName = "Input";
